import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { LoyaltyCurrencyService } from '@rd/core/services/loyalty-currency/loyalty-currency.service';
import { OrderHelper } from '@rd/helpers/order.helper';
import { Order } from '@rd/types';
import { OrderItemStatus } from '@rd/types/order-item.type';
import {
  RcSuccessPageTextMap,
  RedeemCashSettingService,
} from '../../services/redeem-cash-setting/redeem-cash-setting.service';

@Component({
  selector: 'rd-rcv2-success-points-transaction-status',
  templateUrl: './success-points-transaction-status.component.html',
  styleUrls: ['./success-points-transaction-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RcV2SuccessPointsTransactionStatusComponent implements OnInit {
  OrderItemStatus = OrderItemStatus;

  @HostBinding('class.rd-rcv2-success-points-transaction-status')
  componentClass = true;

  successPageText: RcSuccessPageTextMap;

  @Input() redeemCashOrder: Order;

  constructor(
    private iconRegistryService: IconRegistryService,
    private orderHelper: OrderHelper,
    private loyaltyCurrencyService: LoyaltyCurrencyService,
    private redeemCashSettingService: RedeemCashSettingService,
  ) {}

  ngOnInit(): void {
    this.registerIcons();
    this.successPageText = this.redeemCashSettingService.successPageText;
  }

  orderFulfillmentStatus(): OrderItemStatus {
    switch (this.redeemCashOrder.fulfillmentStatus) {
      case OrderItemStatus.Processing: {
        return OrderItemStatus.Pending;
      }
      case OrderItemStatus.Cancelled: {
        return OrderItemStatus.Failed;
      }
      default: {
        return this.redeemCashOrder.fulfillmentStatus;
      }
    }
  }

  orderIdParams(): { id: string } {
    return {
      id: this.orderHelper.displayedId(this.redeemCashOrder),
    };
  }

  refundDisclaimerParams(): { currencyName: string } {
    return {
      // @ts-ignore
      currencyName: this.loyaltyCurrencyService.loyaltyCurrencySelected.name,
    };
  }

  shouldShowTransactionStatusMessage(): boolean {
    if (
      this.redeemCashOrder.fulfillmentStatus === OrderItemStatus.Fulfilled &&
      this.redeemCashSettingService.successPageText.confirmedStatusMessage
    ) {
      return true;
    }

    if (
      (this.redeemCashOrder.fulfillmentStatus === OrderItemStatus.Failed ||
        this.redeemCashOrder.fulfillmentStatus === OrderItemStatus.Cancelled) &&
      this.redeemCashSettingService.successPageText.failedStatusMessage
    ) {
      return true;
    }

    if (
      (this.redeemCashOrder.fulfillmentStatus === OrderItemStatus.Pending ||
        this.redeemCashOrder.fulfillmentStatus ===
          OrderItemStatus.Processing) &&
      this.redeemCashSettingService.successPageText.pendingStatusMessage
    ) {
      return true;
    }

    return false;
  }

  private registerIcons(): void {
    this.iconRegistryService.registerIcon('success');
    this.iconRegistryService.registerIcon('progress');
    this.iconRegistryService.registerIcon('error');
  }
}
